import axiosInstance from './axios';

export const posService = {
  searchProducts: async (search) => {
    const response = await axiosInstance.get('/pos/search-products', {
      params: { search }
    });
    return response.data;
  },

  searchByBarcode: async (barcode) => {
    const response = await axiosInstance.post('/pos/search-barcode', { barcode });
    return response.data;
  },

  createSale: async (saleData) => {
    const response = await axiosInstance.post('/pos/sale', saleData);
    return response.data;
  },

  getTodaySummary: async () => {
    const response = await axiosInstance.get('/pos/today-summary');
    return response.data;
  },
};
